import React, {useState, forwardRef, useImperativeHandle} from 'react';
import Props from 'prop-types';
import { SearchDepartment as SearchDepartmentComponent } from '../../../../../Common/fSubmitInvoice/common/SearchDepartment';


const SearchDepartment = forwardRef((_, ref) => {

    const [value, setValue] = useState('');


    useImperativeHandle(ref, () => ({
        getValue: () => {
            return value;
        }
    }));

    return (
        <>
            <SearchDepartmentComponent office={value} title="Search Department" onSelect={setValue}  />
        </>
    )
})


SearchDepartment.propsTypes = {
    type: Props.string
}

SearchDepartment.defaultProps = {
    type: 'text',
    placeholder: 'Enter the Text',
}


export default SearchDepartment ;
